module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsWomen.0d0dd34.jpg";